export const uiText = {
  title: "Administrador de iniciativas",
  loading: "Cargando...",
  restartForm: "Reiniciar el formulario",

  error: {
    noGetData:
      "No es posible obtener los detalles de la iniciativa, intenta de nuevo más tarde",
  },

  criticalError: {
    user: "Error interno de la app",
    log: "Critical error:",
  },

  initiative: {
    createNew: "Crear iniciativa",
    creatingNew: "Creando iniciativa...",
    cancelCreation: "Cancelar creación de una nueva iniciativa",
    noInitiatives: "No hay iniciativas.",
    disabled: "Inactiva",
    enabled: "Activa",

    accordionResume: {
      disabledPresentation: ", Iniciativa inactiva",
      locationPresentation: "Iniciativa ubicada en:",
    },
  },
};
